import React from "react";
import { GridLoader } from "react-spinners";
import { css } from "@emotion/core";
import styled from 'styled-components';

const Parent = styled.div`
  display: block;
  margin: 0 auto;
  border-color: rgb(211, 58, 144, 100);
  padding-top: 25vh;
  padding-left: 50%;
  height: 100vh;
`;

const Loader = props => {
  const isTabletOrMobile = window.innerWidth < 1224;
  window.scrollTo({ top: 0 });
  return (
    <Parent
      style={{
        paddingLeft: !isTabletOrMobile ? props.paddingLeft? props.paddingLeft: "45%": "38%"
      }}
    >
      <GridLoader
        css={css``}
        sizeUnit={"px"}
        size={25}
        color={"rgb(211, 58, 144, 100)"}
        loading={true}
      />
    </Parent>
  );
};

export default Loader;

